import { z } from "zod";

export const isRequired = (fieldName: string, schema: z.ZodObject<any>) => {
  return (schema.shape as { [key: string]: any })?.[fieldName]._def.typeName === 'ZodOptional' ? false : true;
}